import { OnInit, Component, Inject } from "@angular/core";
import { AdmissionSearchItem } from "../../../model/admission-search-item";
import { AdmissionService } from "../../../services/admission.service";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: 'other-admission-medical-appointment-dialog',
  templateUrl: 'other-admission-medical-appointment-dialog.component.html',
  styleUrls: ['./other-admission-medical-appointment-dialog.component.css']
})
export class OtherAdmissionMedicalAppointmenDialogComponent implements OnInit {

  loading: boolean;
  admissionSearchItems: AdmissionSearchItem[] = [];

  constructor(private admissionService: AdmissionService
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<OtherAdmissionMedicalAppointmenDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async ngOnInit() {
    try {
      this.loading = true;
      this.admissionSearchItems = await this.admissionService.getPatientReceiveAddmissionSearchItems(this.data.patientId, true);
    }
    catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Otros turnos");
    } finally {
      this.loading = false;
    }
  }
}
